module.exports = __webpack_public_path__ + "static/typewise-e5f142dfd29d5556e8036926564f9924.png";